import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=a4a6adea"
import script from "./ComingSoon.vue?vue&type=script&lang=ts"
export * from "./ComingSoon.vue?vue&type=script&lang=ts"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=a4a6adea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports